import CoreTable from '@/components/Table';
import { useCoreContext } from '@/core';
import React from 'react';
import { BusinessUnitTableColumns } from '../../components/TableColumn';
import { get } from 'lodash';
import { Typography } from 'antd';
import { CorePagination } from '@/components/Pagination';

export const BusinessUnitTable = () => {
  const { loading, error, businessUnitData, setValue, getValues } = useCoreContext();
  const tableColumns = BusinessUnitTableColumns();

  return (
    <>
      {error && <div>Error</div>}
      {!error && (
        <div>
          <CoreTable
            columns={tableColumns}
            dataSource={get(businessUnitData, 'data') ?? []}
            tableName='BusinessUnit'
            loading={loading}
          />
          <div className='flex mt-4 justify-between'>
            <Typography.Title level={3}>
              Total:{' '}
              {get(businessUnitData, 'count') > 999 ? '>= 1000' : get(businessUnitData, 'count')}
            </Typography.Title>
            <CorePagination
              total={get(businessUnitData, 'count') ?? 0}
              defaultPageSize={10}
              showSizeChanger
              pageSizeOptions={['5', '10', '20']}
              onChange={(page, pageSize) => {
                setValue('page', page);
                setValue('limit', pageSize);
              }}
              current={getValues('page')}
            />
          </div>
        </div>
      )}
    </>
  );
};
